import { Pipe, PipeTransform } from '@angular/core';

export abstract class LinguaBase
{
    public abstract getOrdinalSuffix(value: number): string;
    public abstract getNumberText(value: number): string;
    public abstract getOrdinalText(value: number): string;
}

export class Lingua
{
    public getOrdinalSuffix(value: number): string
    {
        let dayText: string = value.toString();
        let lastChar: string = dayText.charAt(dayText.length - 1);
        let isTeens: boolean = dayText.length > 1 && dayText.charAt(dayText.length - 2) == "1";

        if (lastChar == "1" && !isTeens)
            return "st";

        if (lastChar == "2" && !isTeens) 
            return "nd";

        if (lastChar == "3" && !isTeens)
            return "rd";

        return "th";
    }

    public getNumberText(value: number): string
    {
        if (value == 0)
            return "NONE";
        else if (value == 1)
            return "ONE";
        else if (value == 2)
            return "TWO";
        else if (value == 3)
            return "THREE";
        else if (value == 4)
            return "FOUR";
        else if (value == 5)
            return "FIVE";
        else if (value == 6)
            return "SIX";
        else if (value == 7)
            return "SEVEN";
        else if (value == 8)
            return "EIGHT";
        else if (value == 9)
            return "NINE";
        else if (value == 10)
            return "TEN";

        return "";
    }

    public getOrdinalText(value: number): string
    {
        if (value == 1)
            return "FIRST";
        else if (value == 2)
            return "SECOND";
        else if (value == 3)
            return "THIRD";
        else if (value == 4)
            return "FOURTH";
        else if (value == 5)
            return "FIFTH";
        else if (value == 6)
            return "SIXTH";
        else if (value == 7)
            return "SEVENTH";
        else if (value == 8)
            return "EIGHTH";
        else if (value == 9)
            return "NINTH";
        else if (value == 10)
            return "TENTH";

        return "";
    }

}

@Pipe({ name: 'linguaOrdinalSuffix' })
export class LinguaOrdinalSuffixPipe implements PipeTransform
{
    private _lingua: LinguaBase;

    constructor(lingua: LinguaBase)
    {
        this._lingua = lingua;
    }

    public transform(value: number): any
    {
        return this._lingua.getOrdinalSuffix(value);
    }
}




// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/shared/core/ovs.lingua.ts